// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RequestPremiumLicenseContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-requestpremiumlicensecontainer" */ "./RequestPremiumLicenseContainer")).then((bundle)=>{
        return {
            default: bundle.RequestPremiumLicenseContainer
        };
    });
export const LazyRequestPremiumLicenseContainer = /*#__PURE__*/ lazy(RequestPremiumLicenseContainerLazyLoader);
